export default {
  'default_error': 'Unknown error.',
  'unknown_error': 'Unknown error.',
  'unknown_message_type': 'Unknown message type.',
  'no_response_from_server': 'No response from server.',
  'registration_successful': 'Registration successful!',
  'no_such_user': 'No such user.',
  'login_failed': 'Login failed.',
  'incorrect_username_or_password': 'Incorrect username or password.',
  'login_successful': 'Login successful!',
  'action_unallowed': 'Action unallowed.',
  'request_canceled_by_user': 'Upload canceled.',
  'st_token_set_successfully': 'ScanTrust token is set successfully!'
}